import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
      fontFamily: 'Poppins, Arial, sans-serif',
    },
    palette: {
        primary: {
          main: '#121212',
          light: '#2C2C2C',
          dark: '#234B67',
          medio: '#f7f7f7',
          btn: '#314c53',
          btn2: '#5a7f78',
          black: 'black'
        },
        secondary: {
        //   main: '#030608',
          main: '#2F678E',
          light: '#3A83B6',
          dark: '#132837',
          lateral: '#b0c2cf'
        },
      },
      components: {
        MuiBox: {
          styleOverrides: {
            root: {
              padding: '16px',
            },
          },
        },
        MuiTableHead: {
          styleOverrides: {
            root: {
              backgroundColor: 'black', 
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: '#2C2C2C',
            }
          }
        }
      },
});

export default theme;